export default __webpack_public_path__ + "locales/fi/EmptyTrashDialog.json?hash=35abe750ea2058f6dee1abedd16db8dc";